import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import React from 'react';

function Track(props) {
  var _ref, _ref2;

  var prefixCls = props.prefixCls,
      vertical = props.vertical,
      reverse = props.reverse,
      bound = props.bound,
      min = props.min,
      max = props.max;
  var range = max - min;
  var offset = "".concat(Math.abs(bound - min) / range * 100, "%");
  var trackStyle = vertical ? (_ref = {}, _defineProperty(_ref, reverse ? 'top' : 'bottom', '0%'), _defineProperty(_ref, reverse ? 'bottom' : 'top', 'auto'), _defineProperty(_ref, "height", offset), _ref) : (_ref2 = {}, _defineProperty(_ref2, reverse ? 'right' : 'left', '0%'), _defineProperty(_ref2, reverse ? 'left' : 'right', 'auto'), _defineProperty(_ref2, "width", offset), _ref2);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-track"),
    style: trackStyle
  });
}

export default Track;